<mat-spinner-button [class.has-icon]="!!icon" [options]="options" (btnClick)="onBtnClick($event)"></mat-spinner-button>
<template #contentRef><ng-content></ng-content></template>
